// src/plugins/alert.js

import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

/**
 * Uso en Composition API:
 * import { alert } from '@/plugins/alert';
 * alert.show({ title: 'Atención', text: 'Cuerpo del mensaje' });
 * alert.toast({ title: 'Éxito', icon: 'success' });
 */

export const alert = {
  // Método principal para alertas
  show: ({
    title = 'Atención',
    text = '',
    icon = 'info',
    confirmButtonText = 'Aceptar',
    showCancelButton = false,
    cancelButtonText = 'Cancelar',
    ...opts
  } = {}) => {
    return Swal.fire({
      title,
      text,
      icon,
      confirmButtonText,
      showCancelButton,
      cancelButtonText,
      ...opts
    });
  },

  // Alias para toasts (notificaciones rápidas)
  toast: ({
    icon = 'success',
    title = '',
    timer = 3000,
    position = 'top-end',
    ...opts
  } = {}) => {
    const Toast = Swal.mixin({
      toast: true,
      position,
      showConfirmButton: false,
      timer,
      timerProgressBar: true,
      ...opts
    });
    return Toast.fire({ icon, title });
  }
}; 

export default {
  install: (app) => {
    // Hace accesible globalmente como $alert y $toast
    app.config.globalProperties.$alert = (opts) => alert.show(opts);
    app.config.globalProperties.$toast = (opts) => alert.toast(opts);
    
    app.provide('alert', alert);
  }
};